import { render, staticRenderFns } from "./DmpEventData.vue?vue&type=template&id=52515590&scoped=true"
import script from "./DmpEventData.vue?vue&type=script&lang=js"
export * from "./DmpEventData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52515590",
  null
  
)

export default component.exports